import { css } from '@eti/styles';
import { breakpoints, Button, Inline, Stack, Text } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import { Lock } from '@phosphor-icons/react';
import TitledCard from '../../../../../common/components/TitledCard';

const buttonStyles = css`
  width: fit-content;

  @media (max-width: ${breakpoints._768}) {
    width: 100%;
  }
`;

interface PriceLockCardProps {
  description: string;
  title: string;
}

const PriceLockCard = ({ description, title }: PriceLockCardProps) => {
  const { t } = useTranslation();

  return (
    <TitledCard headingLevel={3} title={title}>
      <Stack spacing={16}>
        <Text asHtml>{description}</Text>
        <Button
          className={buttonStyles}
          // TODO: Add PriceLockCard button logic as per figma in DSO-1431
          onClick={() => null}
          variant="secondary"
        >
          <Inline alignY="center" spacing={8}>
            <Lock size={20} weight="bold" />
            {t('Result.Page.ItineraryDrawer.PriceLock.Card.Button.Text')}
          </Inline>
        </Button>
      </Stack>
    </TitledCard>
  );
};

export default PriceLockCard;
